const MediaSize = {
  large: 'large',
  medium: 'medium',
  small: 'small',
};

export { MediaSize };
